var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSymbolList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M15.521,0.656H4.479c-0.965,0-1.75,0.785-1.75,1.75v15.188c0,0.965,0.785,1.75,1.75,1.75h11.043 c0.965,0,1.75-0.785,1.75-1.75V2.406C17.271,1.441,16.486,0.656,15.521,0.656z M15.771,17.594c0,0.138-0.112,0.25-0.25,0.25H4.479 c-0.138,0-0.25-0.112-0.25-0.25V2.406c0-0.138,0.112-0.25,0.25-0.25h11.043c0.138,0,0.25,0.112,0.25,0.25V17.594z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M13.625,5.613h-7.25c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75h7.25 c0.414,0,0.75-0.336,0.75-0.75S14.039,5.613,13.625,5.613z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M13.625,9.25h-7.25c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75h7.25c0.414,0,0.75-0.336,0.75-0.75 S14.039,9.25,13.625,9.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M10.563,12.887H6.375c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75h4.188 c0.414,0,0.75-0.336,0.75-0.75S10.977,12.887,10.563,12.887z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolList);
export default __webpack_public_path__ + "static/media/symbol-list.b129136d.svg";
export { ForwardRef as ReactComponent };